import { useEffect } from 'react';
import LegalPage from '@/components/LegalPage';
import { communityGuidelinesSV, communityGuidelinesEN } from '@/data/legal/community-guidelines';

export default function CommunityGuidelinesPage() {
  useEffect(() => {
    document.title = 'Communityregler - Beredskapshubben';
  }, []);

  return (
    <LegalPage 
      titleSV="Communityregler"
      titleEN="Community Guidelines"
      contentSV={communityGuidelinesSV}
      contentEN={communityGuidelinesEN}
    />
  );
}
